import { DocumentType, VehicleDocumentsResponse, DOCUMENT_TYPES } from 'api/document/document.types';
import { TENANT } from 'config/constant';
import dayjs from 'dayjs';
import { formatPatent } from 'global/utils/plate/patente';

export const namesStrategy: Record<DocumentType, { compactName: string; name: string }> = {
  cav: {
    compactName: 'CAV',
    name: 'Certificado de Anotaciones Vigentes',
  },
  comprobante_banco: {
    compactName: 'Comprobante Banco',
    name: 'Comprobante Banco',
  },
  contrato_activacion_tag: {
    compactName: 'Convenio TAG',
    name: 'Convenio TAG',
  },
  factura: {
    compactName: 'Factura',
    name: `Factura`,
  },
  formulario_88: {
    compactName: 'Formulario 88',
    name: 'Formulario 88',
  },
  homologado: {
    compactName: 'CHI-E',
    name: `Certificado de Homologación (CHI-e)`,
  },
  mlt: {
    compactName: 'MLT',
    name: 'Certificado Multas No Pagadas (MLT)',
  },
  nota_credito: {
    compactName: 'Nota de Crédito',
    name: 'Nota de Crédito',
  },
  padron: {
    compactName: 'Padrón',
    name: `Certificado de Inscripción (Padrón)`,
  },
  permiso_circulacion: {
    compactName: 'PCV',
    name: `Permiso de Circulación Vehicular (PCV)`,
  },
  porta_dox: {
    compactName: 'Porta Dox',
    name: 'Porta Dox',
  },
  revision_tecnica: {
    compactName: 'Revisión Técnica',
    name: 'Revisión Técnica',
  },
  seguro_obligatorio: {
    compactName: 'SOAP',
    name: `Certificado SOAP`,
  },
  solicitud_primera_inscripcion: {
    compactName: 'Solicitud Primera Inscripción',
    name: 'Solicitud Primera Inscripción',
  },
  solicitud_transferencia: {
    compactName: 'Solicitud Transferencia',
    name: 'Solicitud Transferencia',
  },
  tarjeta_vehicular: {
    compactName: 'Tarjeta Vehicular',
    name: 'Tarjeta Vehicular',
  },
  contrato: {
    compactName: 'Contrato',
    name: 'Contrato',
  },
  factura_electronica_exenta: {
    compactName: 'Factura exenta',
    name: 'Factura exenta',
  },
};

export const transformVehicleDocumentsInputFromServer = (
  response: VehicleDocumentsResponse,
): VehicleDocumentsResponse => {
  const items = response?.result?.documentos
    ?.filter(doc => DOCUMENT_TYPES.includes(doc.type) && namesStrategy[doc.type])
    ?.sort((doc1, doc2) => dayjs(doc2.inserted_at).valueOf() - dayjs(doc1.inserted_at).valueOf());

  const docsGroupByType = items?.reduce((acc, doc) => {
    if (!acc[doc.type]) {
      acc[doc.type] = [];
    }

    acc[doc.type].push(doc);
    return acc;
  }, {} as any);

  const order = [
    'factura',
    'factura_electronica_exenta',
    'contrato',
    'nota_credito',
    'solicitud_primera_inscripcion',
    'solicitud_transferencia',
    'padron',
    'cav',
    'mlt',
    'revision_tecnica',
    'homologado',
    'seguro_obligatorio',
    'permiso_circulacion',
    'porta_dox',
    'contrato_activacion_tag',
    'tarjeta_vehicular',
    'comprobante_banco',
    'formulario_88',
  ];

  const docs = order.map(docType => docsGroupByType?.[docType] ?? []).flat(2);

  return {
    ...response,
    result: {
      ...response.result,
      documents: docs?.map(doc => {
        // @ts-ignore
        const desc = namesStrategy[doc.type];

        return {
          id: doc.unique_id,
          ...desc,
          canDelete: doc.type !== 'tarjeta_vehicular' && docsGroupByType[doc.type][0].unique_id !== doc.unique_id,
          createAt: dayjs(doc.inserted_at).format('DD/MM/YYYY'),
          downloadUrl: `/nodeservice/download/tenant/${TENANT}/node/${doc.unique_id}`,
          fileName: `${desc.compactName}-${dayjs(doc.inserted_at).format('DD-MM-YYYY')}-${formatPatent(
            response.result?.vehiculo?.patente,
          )}`,
          type: doc.type,
          url: `/nodeservice/preview/tenant/${TENANT}/node/${doc.unique_id}`,
        };
      }),
    },
  };
};
